import { render, staticRenderFns } from "./fund-top-holdings-panel.vue?vue&type=template&id=3b54b1f8&"
var script = {}
import style0 from "./fund-top-holdings-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports